import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b6becbe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/static/css/home/list.css?vue&type=style&index=0&id=5b6becbe&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6becbe",
  null
  
)

export default component.exports